import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';

import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-register-steps-report',
  templateUrl: './register-steps-report.component.html',
  styleUrls: ['./register-steps-report.component.scss']
})
export class RegisterStepsReportComponent implements OnInit {

  @ViewChild('barChartContainer', { static: false }) barChartContainer!: ElementRef<any>;
  @ViewChild('lineChartContainer', { static: false }) lineChartContainer!: ElementRef<any>;
  barChartWidth: number = 0;
  lineChartWidth: number = 0;
  barChartData: any = []
  lineChartData: any = [
    {
      name: "Até segundo passo",
      series: [

      ]
    },
    {
      name: "Terceiro passo",
      series: [

      ]
    },
    {
      name: "Quarto passo",
      series: [

      ]
    },
  ]
  submiting: boolean = false;

  constructor(
    private http: HttpService,
    private erroReport: ErrorReportService
  ) {

  }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {
      if (scope == 'analytics:register_steps') {
        this.submiting = trigger == 'pre';
      }

    })
    this.http.setLoadingIndicator(subject, 'analytics:register_steps')

  }

  getRegisterSteps() {

    this.http.list('analytics:register_steps')
      .subscribe(
        (registerSteps: any) => {
          this.barChartData = [
            {
              name: 'Até o segundo passo',
              value: parseInt(registerSteps.stepTwo.records)
            },
            {
              name: 'Até o terceiro passo',
              value: parseInt(registerSteps.stepThree.records)
            },
            {
              name: 'Cadastro completo',
              value: parseInt(registerSteps.stepFour.records)
            },
          ]

          setTimeout(() => {
            this.barChartWidth = this.barChartContainer.nativeElement.clientWidth;
            this.lineChartWidth = this.lineChartContainer.nativeElement.clientWidth;
          }, 250)
        },
        err => this.erroReport.showMessage(err)
      )

    this.http.list('analytics:register_steps', { groupByDate: true })
      .subscribe(
        (registerSteps: any) => {
          this.lineChartData[0].series = registerSteps.stepTwo.map((item: any) => ({
            name: moment(item.date_added).format('DD/MM/YYYY'),
            value: item.records
          }));
          this.lineChartData[1].series = registerSteps.stepThree.map((item: any) => ({
            name: moment(item.date_added).format('DD/MM/YYYY'),
            value: item.records
          }));
          this.lineChartData[2].series = registerSteps.stepFour.map((item: any) => ({
            name: moment(item.date_added).format('DD/MM/YYYY'),
            value: item.records
          }));
          // console.log(this.lineChartData)
        },
        err => this.erroReport.showMessage(err)
      )

  }

}
